<span class="num" id="td_lotto_countdown_days_1">{{d}}d</span> | <span class="num" id="td_lotto_countdown_hour_1">{{h}}h</span> |
<span class="num" id="td_lotto_countdown_minute_1">{{m}}m</span> |
<span class="num" id="td_lotto_countdown_second_1">{{s}}s</span>
